import React, { useState } from "react";
import { Link } from "react-router-dom";
import Button from "../../components/Button/Button";
import MaterialIcons from "../../components/MaterialIcons";
import socials from "../../utils/socials";
import emailjs from "emailjs-com";
import "./contact.scss";

const Contact = () => {
	const [user, setUser] = useState({
		name: "",
		email: "",
		message: "",
	});
	const handleChange = (e) => {
		const { name, value } = e.target;
		setUser((p) => ({ ...p, [name]: value }));
	};
	const handleSubmit = (e) => {
		e.preventDefault();
		emailjs
			.sendForm(
				process.env.REACT_APP_SERVICE,
				process.env.REACT_APP_TEMPLATE,
				e.target,
				process.env.REACT_APP_USER
			)
			.then((res) => console.info(res))
			.catch((err) => console.error(err));
		alert("Your message has been sent");
		setUser({
			name: "",
			email: "",
			message: "",
		});
	};
	const handleReset = (e) => {
		e?.preventDefault();
		setUser({
			name: "",
			email: "",
			message: "",
		});
	};
	return (
		<main className="contact">
			<div className="contact-mac" data-aos="zoom-in">
				<div className="contact-mac-head">
					<div className="contact-mac-head-buttons">
						<button className="contact-mac-head__button">
							<Link to="/">
								<MaterialIcons>close</MaterialIcons>
							</Link>
						</button>
						<button className="contact-mac-head__button">
							<Link to={-1}>
								<MaterialIcons>remove</MaterialIcons>
							</Link>
						</button>
						<button className="contact-mac-head__button">
							<MaterialIcons>open_in_full</MaterialIcons>
						</button>
					</div>
					<div className="contact-mac-head-title">
						<span className="contact-mac-head-title__text">
							Contact Us
						</span>
					</div>
					<div className="contact-mac-head-switch"></div>
				</div>
				<div className="contact-mac-body">
					<div className="contact-mac-body-container">
						<div className="contact-mac-left">
							<h1>Contact Us</h1>
							<div className="contact-socials">
								{socials.map((social) => (
									<a href={social.link}>
										<span>{social.icon}</span>
										<span>{social.username}</span>
									</a>
								))}
							</div>
						</div>
						<div className="contact-mac-right">
							<h2>Get In Touch</h2>
							<form onSubmit={handleSubmit} onReset={handleReset}>
								<input
									value={user.name}
									name="name"
									placeholder="Your Name"
									onChange={handleChange}
									type="text"
									required
								/>
								<input
									value={user.email}
									name="email"
									placeholder="Your email"
									onChange={handleChange}
									type="email"
									required
								/>
								<textarea
									rows={6}
									value={user.message}
									name="message"
									placeholder="Type your message here"
									onChange={handleChange}
									type="text"
									required
								></textarea>
								<div className="contact-form-group">
									<Button
										text="Cancel"
										type="reset"
										variant="outline"
										color="black"
										style={{
											color: "var(--white)",
										}}
									/>
									<Button text="Send Message" type="submit" />
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
		</main>
	);
};

export default Contact;
